<!-- 商品中心 - 商品列表  -->
<template>

  <!-- 搜索工作栏 -->
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="商品名称" prop="name">
        <el-input
          v-model="queryParams.name"
          class="!w-240px"
          clearable
          placeholder="请输入商品名称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="商品分类" prop="categoryId">
        <el-cascader
          v-model="queryParams.categoryId"
          :options="categoryList"
          :props="defaultProps"
          class="w-1/1"
          clearable
          filterable
          placeholder="请选择商品分类"
        />
      </el-form-item>
      <el-form-item label="所属店铺" prop="shopId">
        <el-select
          v-model="queryParams.shopId"
          class="!w-240px"
          clearable
          filterable
          placeholder="请选择店铺"
        >
          <el-option
            v-for="item in shopFilterOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="商品来源" prop="productSource">
        <el-select
          v-model="queryParams.productSource"
          class="!w-240px"
          clearable
          placeholder="请选择来源"
        >
          <el-option label="集采" :value="1" />
          <el-option label="外发" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="供应商" prop="supplierId">
        <el-select
          v-model="queryParams.supplierId"
          class="!w-240px"
          clearable
          filterable
          placeholder="请选择供应商"
        >
          <el-option
            v-for="item in supplierFilterOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="货源渠道" prop="sourceChannel">
        <el-select
          v-model="queryParams.sourceChannel"
          class="!w-240px"
          clearable
          placeholder="请选择渠道"
        >
          <el-option
            v-for="item in SourceChannelOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
          class="!w-240px"
          end-placeholder="结束日期"
          start-placeholder="开始日期"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['product:spu:create']"
          plain
          type="primary"
          @click="openForm(undefined)"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
        <el-button
          v-hasPermi="['product:spu:export']"
          :loading="exportLoading"
          plain
          type="success"
          @click="handleExport"
        >
          <Icon class="mr-5px" icon="ep:download" />
          导出
        </el-button>
        <el-button
          v-hasPermi="['product:spu:import-saleable']"
          plain
          type="warning"
          @click="openSaleableImport"
        >
          <Icon class="mr-5px" icon="ep:upload" />
          导入可售更新
        </el-button>
        <el-button
          v-hasPermi="['product:spu:import-create']"
          plain
          type="warning"
          @click="openCreateImport"
        >
          <Icon class="mr-5px" icon="ep:upload" />
          导入新建商品
        </el-button>
        <el-button
          v-hasPermi="['product:spu:update']"
          plain
          type="success"
          :disabled="!selectedIds.length"
          :loading="batchStatusLoading"
          @click="handleBatchStatus(ProductSpuStatusEnum.ENABLE.status)"
        >
          批量上架
        </el-button>
        <el-button
          v-hasPermi="['product:spu:update']"
          plain
          type="danger"
          :disabled="!selectedIds.length"
          :loading="batchStatusLoading"
          @click="handleBatchStatus(ProductSpuStatusEnum.DISABLE.status)"
        >
          批量下架
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <!-- 列表 -->
  <ContentWrap>
    <el-tabs v-model="queryParams.tabType" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="item in tabsData"
        :key="item.type"
        :label="item.name + '(' + item.count + ')'"
        :name="item.type"
      />
    </el-tabs>
    <el-table
      v-loading="loading"
      :data="list"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="48" :selectable="rowSelectable" />
      <el-table-column type="expand">
        <template #default="{ row }">
          <el-form class="spu-table-expand" label-position="left">
            <el-row>
              <el-col :span="24">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="商品分类:">
                      <span>{{ formatCategoryName(row.categoryId) }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="市场价:">
                      <span>{{ fenToYuan(row.marketPrice) || '—' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="成本价:">
                      <span>{{ fenToYuan(row.costPrice) || '—' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="浏览量:">
                      <span>{{ row.browseCount }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="虚拟销量:">
                      <span>{{ row.virtualSalesCount }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="商品编号" min-width="140" prop="id" />
      <el-table-column label="店铺" width="120">
        <template #default="{ row }">{{ shopName(row.shopId) }}</template>
      </el-table-column>
      <el-table-column align="center" label="来源" width="80">
        <template #default="{ row }">
          <span v-if="row.productSource === 1">集采</span>
          <span v-else-if="row.productSource === 2">外发</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="供应商" min-width="110" show-overflow-tooltip>
        <template #default="{ row }">{{ row.supplierName || '-' }}</template>
      </el-table-column>
      <el-table-column align="center" label="货源渠道" width="100">
        <template #default="{ row }">{{ row.sourceChannelName || '-' }}</template>
      </el-table-column>
      <el-table-column align="center" label="货源链接" min-width="120" show-overflow-tooltip>
        <template #default="{ row }">
          <el-link
            v-if="row.sourceUrl"
            :href="row.sourceUrl"
            target="_blank"
            type="primary"
            :underline="false"
          >
            打开
          </el-link>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="商品信息" min-width="300">
        <template #default="{ row }">
          <div class="flex">
            <el-image
              fit="cover"
              :src="row.picUrl"
              class="flex-none w-50px h-50px"
              @click="imagePreview(row.picUrl)"
            />
            <div class="ml-4 overflow-hidden">
              <el-tooltip effect="dark" :content="row.name" placement="top">
                <div>
                  {{ row.name }}
                </div>
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="价格" min-width="160" prop="price">
        <template #default="{ row }"> ¥ {{ fenToYuan(row.price) }}</template>
      </el-table-column>
      <el-table-column align="center" label="销量" min-width="90" prop="salesCount" />
      <el-table-column align="center" label="库存" min-width="90" prop="stock" />
      <el-table-column align="center" label="排序" min-width="70" prop="sort" />
      <el-table-column align="center" label="审核状态" min-width="90">
        <template #default="{ row }">
          <template v-if="row.auditStatus != null && row.auditStatus !== undefined">
            <el-tag v-if="row.auditStatus === 0" type="info" size="small">草稿</el-tag>
            <el-tag v-else-if="row.auditStatus === 1" type="warning" size="small">审核中</el-tag>
            <el-tag v-else-if="row.auditStatus === 2" type="success" size="small">审核通过</el-tag>
            <el-tag v-else-if="row.auditStatus === 3" type="danger" size="small">审核不通过</el-tag>
            <el-tag v-else-if="row.auditStatus === 4" type="success" size="small">已上架</el-tag>
            <el-tag v-else-if="row.auditStatus === 5" type="info" size="small">已下架</el-tag>
            <el-tag v-else size="small">-</el-tag>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="销售状态" min-width="80">
        <template #default="{ row }">
          <template v-if="row.status >= 0">
            <el-switch
              v-model="row.status"
              :active-value="1"
              :inactive-value="0"
              active-text="上架"
              inactive-text="下架"
              inline-prompt
              @change="handleStatusChange(row)"
            />
          </template>
          <template v-else>
            <el-tag type="info">回收站</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" fixed="right" label="操作" min-width="280">
        <template #default="{ row }">
          <el-button link type="primary" @click="openDetail(row.id)"> 详情 </el-button>
          <el-button
            v-hasPermi="['product:spu:update']"
            link
            type="primary"
            @click="openForm(row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['distribution:spu-config:save']"
            link
            type="primary"
            @click="openDistConfig(row)"
          >
            分销配置
          </el-button>
          <el-button
            v-if="row.auditStatus === 1"
            v-hasPermi="['product:spu:audit']"
            link
            type="warning"
            @click="handleAudit(row)"
          >
            审核
          </el-button>
          <template v-if="queryParams.tabType === 4">
            <el-button
              v-hasPermi="['product:spu:delete']"
              link
              type="danger"
              @click="handleDelete(row.id)"
            >
              删除
            </el-button>
            <el-button
              v-hasPermi="['product:spu:update']"
              link
              type="primary"
              @click="handleStatus02Change(row, ProductSpuStatusEnum.DISABLE.status)"
            >
              恢复
            </el-button>
          </template>
          <template v-else>
            <el-button
              v-hasPermi="['product:spu:update']"
              link
              type="danger"
              @click="handleStatus02Change(row, ProductSpuStatusEnum.RECYCLE.status)"
            >
              回收
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <!-- 商品审核对话框 -->
  <AuditDialog
    ref="auditDialogRef"
    @success="handleAuditSuccess"
  />
  <!-- 商品分销配置对话框（区域代理 / 返现；数据存 product_spu_dist_ext） -->
  <DistConfigDialog ref="distConfigDialogRef" @success="getList" />
  <ProductExcelImportForm
    ref="saleableImportRef"
    title="导入可售更新"
    hint="流程：下载模板 → 按 SKU 改销售价/市场价/成本价/结算价/库存等 → 上传。勿改「SKU编号」。任一失败整表不写入。"
    template-tip="模板=当前筛选下的可售 SKU 清单（带数据）"
    template-file-name="商品可售更新模板.xlsx"
    :download-template-api="downloadSaleableTemplate"
    :import-api="ProductSpuApi.importSaleableSpu"
    @success="getList"
  />
  <ProductExcelImportForm
    ref="createImportRef"
    title="导入新建商品"
    hint="流程：下载模板 → 按示例填写（同「导入分组键」多行=同一商品；多规格如 颜色:红;尺码:L，属性须已存在）→ 上传。任一失败整表不写入。"
    template-tip="模板含表头与示例行（单规格/多规格）"
    template-file-name="新建商品导入模板.xlsx"
    :download-template-api="downloadCreateTemplate"
    :import-api="ProductSpuApi.importCreateSpu"
    @success="getList"
  />
</template>
<script lang="ts" setup>
import { TabsPaneContext } from 'element-plus'
import { createImageViewer } from '@/components/ImageViewer'
import { dateFormatter } from '@/utils/formatTime'
import { defaultProps, handleTree, treeToString } from '@/utils/tree'
import { ProductSpuStatusEnum } from '@/utils/constants'
import { fenToYuan } from '@/utils'
import download from '@/utils/download'
import * as ProductSpuApi from '@/api/mall/product/spu'
import * as ProductCategoryApi from '@/api/mall/product/category'
import { getSimpleSupplierList } from '@/api/mall/product/supplier'
import { getShopSimpleList } from '@/api/merchant/shop-manager'
import { AuditDialog, DistConfigDialog } from './components'
import ProductExcelImportForm from './components/ProductExcelImportForm.vue'
import { useShopName } from '@/hooks/web/useShopName'
import { useMallStandaloneNav } from '@/hooks/web/useMallStandaloneNav'
import {
  readMallUiScope,
  type MallUiScope
} from '@/layout/standalone/mallMenuScopes'
import {
  ensureDefaultSelfOperatedShops,
  pickDefaultSelfOperatedShopId
} from '@/utils/mallSelfOperatedShop'
import { inject, type Ref, watch } from 'vue'

defineOptions({ name: 'ProductSpu' })

const SourceChannelOptions = [
  { label: '京东', value: 1 },
  { label: '天猫', value: 2 },
  { label: '淘宝', value: 3 },
  { label: '拼多多', value: 4 },
  { label: '1688', value: 5 },
  { label: '抖音电商', value: 6 },
  { label: '其他', value: 9 }
]

const { shopName } = useShopName()
const message = useMessage() // 消息弹窗
const route = useRoute() // 路由
const { t } = useI18n() // 国际化
const { pushMall } = useMallStandaloneNav()

const loading = ref(false) // 列表的加载中
const exportLoading = ref(false) // 导出的加载中
const batchStatusLoading = ref(false) // 批量上下架
const total = ref(0) // 列表的总页数
const list = ref<ProductSpuApi.Spu[]>([]) // 列表的数据
const selectedRows = ref<ProductSpuApi.Spu[]>([])
const selectedIds = computed(() =>
  selectedRows.value.map((row) => row.id).filter((id): id is number => id != null)
)
// tabs 数据
const tabsData = ref([
  {
    name: '出售中',
    type: 0,
    count: 0
  },
  {
    name: '仓库中',
    type: 1,
    count: 0
  },
  {
    name: '已售罄',
    type: 2,
    count: 0
  },
  {
    name: '警戒库存',
    type: 3,
    count: 0
  },
  {
    name: '回收站',
    type: 4,
    count: 0
  }
])

const queryParams = ref({
  pageNo: 1,
  pageSize: 10,
  tabType: 0,
  name: '',
  categoryId: undefined as number | undefined,
  shopId: undefined as number | undefined,
  supplierId: undefined as number | undefined,
  productSource: undefined as number | undefined,
  sourceChannel: undefined as number | undefined,
  createTime: undefined
}) // 查询参数
const queryFormRef = ref() // 搜索的表单Ref
const shopFilterOptions = ref<{ id: number; name: string }[]>([])
const supplierFilterOptions = ref<{ id: number; name: string }[]>([])
/** 独立窗注入的经营视角；非独立窗回落 localStorage */
const injectedMallScope = inject<Ref<MallUiScope> | undefined>('mallUiScope', undefined)

const resolveSelfScope = () =>
  (injectedMallScope?.value ?? readMallUiScope()) === 'self'

/** 按当前视角刷新店铺筛选项（切平台↔自营时须重跑） */
const refreshShopFilterOptions = async () => {
  const selfScope = resolveSelfScope()
  if (selfScope) {
    const selfShops = await ensureDefaultSelfOperatedShops()
    shopFilterOptions.value = selfShops.map((s) => ({
      id: s.id,
      name: s.name || `店铺${s.id}`
    }))
    const def = pickDefaultSelfOperatedShopId(selfShops)
    if (def) {
      queryParams.value.shopId = def
    } else if (
      queryParams.value.shopId &&
      !shopFilterOptions.value.some((s) => s.id === queryParams.value.shopId)
    ) {
      queryParams.value.shopId = undefined
    }
  } else {
    const shops = (await getShopSimpleList()) as { id: number; name: string }[]
    shopFilterOptions.value = (shops || []).map((s) => ({
      id: s.id,
      name: s.name || `店铺${s.id}`
    }))
  }
}

if (injectedMallScope) {
  watch(
    injectedMallScope,
    async () => {
      await refreshShopFilterOptions()
      await getTabsCount()
      await getList()
    },
    { flush: 'post' }
  )
}

/** 查询列表 */
const getList = async () => {
  loading.value = true
  try {
    const data = await ProductSpuApi.getSpuPage(queryParams.value)
    list.value = data.list
    total.value = data.total
    selectedRows.value = []
  } finally {
    loading.value = false
  }
}

/** 切换 Tab */
const handleTabClick = (tab: TabsPaneContext) => {
  queryParams.value.tabType = tab.paneName as number
  selectedRows.value = []
  getList()
}

/** 获得每个 Tab 的数量 */
const getTabsCount = async () => {
  const res = await ProductSpuApi.getTabsCount()
  for (let objName in res) {
    tabsData.value[Number(objName)].count = res[objName]
  }
}

/** 添加到仓库 / 回收站的状态 */
const handleStatus02Change = async (row: any, newStatus: number) => {
  try {
    // 二次确认
    const text = newStatus === ProductSpuStatusEnum.RECYCLE.status ? '加入到回收站' : '恢复到仓库'
    await message.confirm(`确认要"${row.name}"${text}吗？`)
    // 发起修改
    await ProductSpuApi.updateStatus({ id: row.id, status: newStatus })
    message.success(text + '成功')
    // 刷新 tabs 数据
    await getTabsCount()
    // 刷新列表
    await getList()
  } catch {}
}

/** 更新上架/下架状态 */
const handleStatusChange = async (row: any) => {
  try {
    // 二次确认
    const text = row.status ? '上架' : '下架'
    await message.confirm(`确认要${text}"${row.name}"吗？`)
    // 发起修改
    await ProductSpuApi.updateStatus({ id: row.id, status: row.status })
    message.success(text + '成功')
    // 刷新 tabs 数据
    await getTabsCount()
    // 刷新列表
    await getList()
  } catch {
    // 异常时，需要重置回之前的值
    row.status =
      row.status === ProductSpuStatusEnum.DISABLE.status
        ? ProductSpuStatusEnum.ENABLE.status
        : ProductSpuStatusEnum.DISABLE.status
  }
}

/** 回收站商品不可勾选上下架 */
const rowSelectable = (row: ProductSpuApi.Spu) => {
  return row.status != null && row.status >= 0
}

const handleSelectionChange = (rows: ProductSpuApi.Spu[]) => {
  selectedRows.value = rows
}

/** 批量上架 / 下架 */
const handleBatchStatus = async (status: number) => {
  const ids = selectedIds.value
  if (!ids.length) {
    message.warning('请先勾选商品')
    return
  }
  const text = status === ProductSpuStatusEnum.ENABLE.status ? '上架' : '下架'
  try {
    await message.confirm(`确认将选中的 ${ids.length} 个商品批量${text}吗？`)
    batchStatusLoading.value = true
    const count = await ProductSpuApi.updateStatusBatch({ ids, status })
    message.success(`批量${text}成功 ${count ?? ids.length} 个`)
    selectedRows.value = []
    await getTabsCount()
    await getList()
  } catch {
    /* 取消或失败 */
  } finally {
    batchStatusLoading.value = false
  }
}

/** 删除按钮操作 */
const handleDelete = async (id: number) => {
  try {
    // 删除的二次确认
    await message.delConfirm()
    // 发起删除
    await ProductSpuApi.deleteSpu(id)
    message.success(t('common.delSuccess'))
    // 刷新tabs数据
    await getTabsCount()
    // 刷新列表
    await getList()
  } catch {}
}

/** 商品图预览 */
const imagePreview = (imgUrl: string) => {
  createImageViewer({
    urlList: [imgUrl]
  })
}

/** 搜索按钮操作 */
const handleQuery = () => {
  getList()
}

/** 重置按钮操作 */
const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

/** 新增或修改 */
const openForm = (id?: number) => {
  if (typeof id === 'number') {
    pushMall(`/product/spu/edit/${id}`)
    return
  }
  pushMall('/product/spu/add')
}

/** 查看商品详情 */
const openDetail = (id: number) => {
  pushMall(`/product/spu/detail/${id}`)
}

/** 导出按钮操作 */
const handleExport = async () => {
  try {
    // 导出的二次确认
    await message.exportConfirm()
    // 发起导出
    exportLoading.value = true
    const data = await ProductSpuApi.exportSpu(queryParams.value)
    download.excel(data, '商品列表.xls')
  } catch {
  } finally {
    exportLoading.value = false
  }
}

/** 可售更新弹窗内「下载模板」= 按当前筛选导出可售清单 */
const downloadSaleableTemplate = () => ProductSpuApi.exportSaleableSpu(queryParams.value)

/** 新建商品弹窗内「下载模板」 */
const downloadCreateTemplate = () => ProductSpuApi.getCreateImportTemplate()

const saleableImportRef = ref<InstanceType<typeof ProductExcelImportForm>>()
const createImportRef = ref<InstanceType<typeof ProductExcelImportForm>>()
const openSaleableImport = () => saleableImportRef.value?.open()
const openCreateImport = () => createImportRef.value?.open()

/** 获取分类的节点的完整结构 */
const categoryList = ref() // 分类树
const formatCategoryName = (categoryId: number) => {
  return treeToString(categoryList.value, categoryId)
}

/** 审核对话框 Ref */
const auditDialogRef = ref()
const distConfigDialogRef = ref()

/** 打开审核对话框 */
const handleAudit = (row: any) => {
  auditDialogRef.value?.open(row)
}

/** 审核成功后刷新列表 */
/** 打开分销配置弹窗 */
const openDistConfig = (row: any) => {
  distConfigDialogRef.value?.open(row)
}

const handleAuditSuccess = () => {
  getTabsCount()
  getList()
}

/** 激活时 */
onActivated(() => {
  getList()
})

/** 初始化 **/
onMounted(async () => {
  // 解析路由的 categoryId
  if (route.query.categoryId) {
    queryParams.value.categoryId = Number(route.query.categoryId)
  }
  await refreshShopFilterOptions()
  // 获得商品信息
  await getTabsCount()
  await getList()
  // 获得分类树
  const data = await ProductCategoryApi.getCategoryList({})
  categoryList.value = handleTree(data, 'id', 'parentId')
  const suppliers = (await getSimpleSupplierList()) as { id: number; name: string }[]
  supplierFilterOptions.value = (suppliers || []).map((s) => ({
    id: s.id!,
    name: s.name || `供应商${s.id}`
  }))
})
</script>
<style lang="scss" scoped>
.spu-table-expand {
  padding-left: 42px;

  :deep(.el-form-item__label) {
    width: 82px;
    font-weight: bold;
    color: #99a9bf;
  }
}
</style>

